
import BScroll from "better-scroll";
import MyCard from "@/components/Card";
import Cookies from "js-cookie";

import Popup from 'vux/src/components/popup/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'


import { requestUrl } from "../../serve/index";

export default {
data() {
this.isShowFilter =
Cookies.get("token") === "gdfz" && this.$route.query.defaultExport;
if (this.isShowFilter) {
document.title = "学期综合评价";
}
return {
isLoading: false,
loadTip: "",
bscroll: "",
bookdata: [],
brwDateStart: "",
brwDateEnd: "",
showPopupPickerSearch: false,
showPopupPickerDownLoad: false,
semesterList: [["全部", "2019学年第一学期", "2019学年第二学期"]],
semesterListDownLoad: [["2019学年第一学期", "2019学年第二学期"]],
semester: ["2019学年第一学期"],
semesterDownLoad: ["2019学年第一学期"]
};
},
components: {
MyCard,
Popup,
LoadMore,
Group,
Datetime,
PopupPicker
},
mounted() {
this.initScroll();
this.getHistoryBorrowList();
if (Cookies.get("token") === "gdfz" && this.$route.query.defaultExport) {
this.$nextTick(() => {
this.isShowFilter = true;
});
}
},
methods: {
handlePopupHide(closeType) {
if (closeType) {
let value = this.semester[0];
switch (value) {
case "全部":
this.requestObj = {
brwDateStart: "",
brwDateEnd: ""
};
this.getHistoryBorrowList();
break;
case "2019学年第一学期":
this.requestObj = {
brwDateStart: "2019-07-15",
brwDateEnd: "2020-01-17",
semester: value
};
this.getHistoryBorrowList();
break;
case "2019学年第二学期":
this.requestObj = {
brwDateStart: "2020-01-18",
brwDateEnd: "2020-07-14",
semester: value
};
this.getHistoryBorrowList();
break;
default:
break;
}
}
},
handlePopupDownLoadHide(closeType) {
if (closeType) {
let value = this.semesterDownLoad[0];
switch (value) {
case "2019学年第一学期":
this.requestObj = {
brwDateStart: "2019-07-15",
brwDateEnd: "2020-01-17",
semester: value
};
this.downLoadPdf();
break;
case "2019学年第二学期":
this.requestObj = {
brwDateStart: "2020-01-18",
brwDateEnd: "2020-07-14",
semester: value
};
this.downLoadPdf();
break;
default:
break;
}
}
},
initScroll() {
let wrapper = document.querySelector(".container__wrapper");
if (!this.bscroll) {
this.bscroll = new BScroll(wrapper, {
pullUpLoad: {
threshold: 50
},
click: true,
bounce: {
top: false,
bottom: false,
left: false,
right: false
}
});
}
},
setRequestObj() {
this.requestObj = {
brwDateStart: this.brwDateStart,
brwDateEnd: this.brwDateEnd
};
this.getHistoryBorrowList();
},
getHistoryBorrowList() {
this.isLoading = true;
this.showPop = false;
this.loadTip = "加载中";
this.bookdata = [];
this.bscroll.scrollTo(0, 0);
this.$http("post", "/book/historyBorrow", this.requestObj || {})
.then(res => {
this.isLoading = false;
if (res.data.length === 0) {
this.loadTip = "暂无数据";
} else {
this.loadTip = "";
}
res.data.forEach(book => {
let bookData = {
bookName: book["题名"],
isbn: book["isbn"],
marcid: book["marcid"],
infos: [
{
name: "条形码",
value: book["条形码"]
},
{
name: "借出日期",
value: book["借出日期"]
},
{
name: "应还日期",
value: book["应还日期"]
},
{
name: "归还日期",
value: book["归还日期"]
}
]
};
this.bookdata.push(bookData);
});
this.$nextTick(() => {
this.bscroll.refresh();
});
})
.catch(() => {
this.isLoading = false;
this.loadTip = "";
});
},
downLoadPdf() {
let openId = Cookies.get("openId") || "";
let token = Cookies.get("token") || "";
let code = Cookies.get("code") || "";
if (openId) {
let href =
location.origin +
requestUrl +
"/book/readerEvaluate" +
`?openId=${openId}&token=${token}&code=${code}&brwDateStart=${this.requestObj.brwDateStart}&brwDateEnd=${this.requestObj.brwDateEnd}&semester=${this.requestObj.semester}`;
let evt = document.createEvent("MouseEvents");
evt.initEvent("click", false, true);
let a = document.createElement("a");
a.setAttribute("href", href);
a.dispatchEvent(evt);
}
},
jumpBookDetail(params, bookdata) {
try {
sessionStorage.setItem("bookInfo", JSON.stringify(bookdata));
} catch (error) {

}
this.$router.push({
path: "/bookDetail",
query: {
isbn: params.isbn,
marcid: params.marcid
}
});
}
}
};
